const consultationData = {
  label: "Untersuchung und individuelle Betreuung",
  title: "Der erste Beratungstermin: Der Beginn Ihrer Reise",
  image: {
    src: "/images/Hiru/public_images/DSC09163-Enhanced-NR-copy.webp",
    alt: "Ayurveda-Untersuchung und Behandlung"
  },
  paragraphs: [
    "Ayurveda, eine ganzheitliche Medizin, legt besonderen Wert darauf, nicht nur einzelne Symptome zu behandeln, sondern K\xF6rper und Geist als Einheit zu betrachten. Viele Beschwerden lassen sich bereits durch eine bewusste Anpassung von Ern\xE4hrung und Alltag verbessern und in eine ges\xFCndere Richtung lenken.",
    "Deshalb h\xF6ren wir bei der ersten Untersuchung sehr sorgf\xE4ltig zu, was Ihre bisherige Lebensgeschichte und Ihr aktueller Zustand betrifft. Dabei sind nicht nur fr\xFChere oder aktuelle Erkrankungen wichtig, sondern auch Ihre Ern\xE4hrung, Ihr t\xE4glicher Lebensstil, Ihre Schlafqualit\xE4t, Ihre Bewegung, Allergien, Beruf, Umwelt, Sorgen und \xC4ngste sowie fr\xFChere Verletzungen.",
    "Je nach Beschwerden pr\xFCfen wir unter anderem den Blutdruck, beobachten sorgf\xE4ltig Augen, Haut, Haare, N\xE4gel und Zunge, achten auf die Tonlage der Stimme und die Atmung und besprechen auch Ihre t\xE4glichen Ausscheidungen.",
    "Besonders wichtig f\xFCr die Ermittlung Ihres Gesundheitszustands und Ihrer bisherigen Geschichte ist die Pulsdiagnostik, auch Nadi Pariksha genannt. Der Arzt legt dabei sanft drei Finger an Ihren Handgelenks-Puls und liest die individuelle Kombination aus Vata, Pitta und Kapha mit gro\xDFer Sensibilit\xE4t ab."
  ],
  planTitle: "Erstellung eines individuellen Behandlungsplans",
  planParagraphs: [
    "Durch diese Beratung wird das Gleichgewicht der Bioenergien \u2013 Vata, Pitta und Kapha \u2013 sichtbar. Auf dieser Grundlage erkl\xE4ren wir Ihnen ausf\xFChrlich Ihren pers\xF6nlichen Behandlungsplan und die empfohlenen Kr\xE4utermischungen.",
    "W\xE4hrend Ihres Aufenthalts, der sich wie ein Zuhause anf\xFChlt, k\xF6nnen Sie sich jederzeit frei mit dem Arzt beraten, auch au\xDFerhalb der festen Untersuchungstermine, wenn Sie Fragen oder Sorgen zur Behandlung haben. So erleben Sie im t\xE4glichen Umgang mit dem Arzt, wie K\xF6rper und Geist langsam in eine ruhige Harmonie und innere Stille finden."
  ]
};
const Header = ({ label, title }) => <div>
        <p className="font-mulish text-xs sm:text-sm font-semibold uppercase tracking-[0.3em] text-amber-800">
            {label}
        </p>
        <h2 className="mt-4 sm:mt-5 font-serif text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-light leading-tight tracking-tight text-[#1f4d3c]">
            {title}
        </h2>
    </div>;
const ImageSection = ({ src, alt, sizes }) => <div className="relative aspect-[4/5] overflow-hidden rounded-[16px] sm:rounded-[24px] bg-transparent shadow-none">
        <img
  src={src}
  alt={alt}
  className="h-full w-full object-contain object-center" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
    </div>;
const ContentParagraphs = ({ paragraphs }) => <div className="space-y-4 sm:space-y-6 font-mulish text-sm sm:text-base md:text-base lg:text-lg leading-7 sm:leading-8 text-gray-700">
        {paragraphs.map((para, idx) => <p key={idx}>{para}</p>)}
    </div>;
const PlanSection = ({ title, paragraphs }) => <div className="pt-4 sm:pt-7 mt-6 sm:mt-10">
        <h3 className="font-serif text-lg sm:text-2xl md:text-2xl lg:text-3xl font-semibold text-[#1f4d3c]">
            {title}
        </h3>
        <div className="mt-3 sm:mt-4 space-y-4 sm:space-y-5 font-mulish text-sm sm:text-base md:text-base lg:text-lg leading-7 sm:leading-8 text-gray-700">
            {paragraphs.map((para, idx) => <p key={idx}>{para}</p>)}
        </div>
    </div>;
const Consultation = () => {
  return <section className="w-full bg-white py-12 sm:py-16 md:py-20 lg:py-28">
            <div className="container mx-auto px-3 sm:px-4 md:px-6 lg:px-8">
                {
    /* Mobile Layout (sm:flex) */
  }
                <div className="mx-auto max-w-7xl lg:hidden">
                    <div className="flex flex-col gap-6 sm:gap-8">
                        <Header label={consultationData.label} title={consultationData.title} />
                        <ImageSection
    src={consultationData.image.src}
    alt={consultationData.image.alt}
    sizes="100vw"
  />
                        <ContentParagraphs paragraphs={consultationData.paragraphs} />
                        <PlanSection title={consultationData.planTitle} paragraphs={consultationData.planParagraphs} />
                    </div>
                </div>

                {
    /* Desktop Layout (hidden on sm, visible on lg) */
  }
                <div className="mx-auto hidden max-w-7xl items-start gap-8 lg:gap-10 xl:gap-16 lg:grid lg:grid-cols-[0.9fr_1.1fr]">
                    <div className="order-1 lg:sticky lg:top-28">
                        <ImageSection
    src={consultationData.image.src}
    alt={consultationData.image.alt}
    sizes="42vw"
  />
                    </div>

                    <div className="order-2">
                        <Header label={consultationData.label} title={consultationData.title} />
                        <div className="mt-6 sm:mt-8">
                            <ContentParagraphs paragraphs={consultationData.paragraphs} />
                        </div>
                        <PlanSection title={consultationData.planTitle} paragraphs={consultationData.planParagraphs} />
                    </div>
                </div>
            </div>
        </section>;
};
export default Consultation;
